import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import {
  TextField as Input,
} from '@material-ui/core';

import { useStyles } from '../login.styles';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { Button, Typography } from '../../../components/Wrappers/Wrappers.jsx';
import useForgotPasswordError from './useForgotPasswordError';
import { useEnvStore } from '../../../store/models';
import { RecoveryState } from '../../../utils/constants';

function ForgotEmail (props) {
  const {
    onSendRecovery,
    onBackToLogin,
  } = props;

  const envStore = useEnvStore();
  const isSending = envStore.recoveryState?.status === RecoveryState.RECOVERY_CODE_SENDING;

  const classes = useStyles();
  const [forgotEmail, setForgotEmail] = useState('');
  const { error } = useForgotPasswordError({ input: null });

  return (
    <div className={classes.form}>
      <Typography variant={'body1'} className={classes.welcomeText}>
        Enter your email to receive your recovery code
      </Typography>
      <Input
        id="email_forgot"
        InputProps={{
          classes: {
            underline: classes.InputUnderline,
            input: classes.Input,
          },
        }}
        value={forgotEmail}
        onChange={e => setForgotEmail(e.target.value)}
        margin="normal"
        placeholder="Email"
        type="Email"
        error={error.emailVerify}
        helperText={ error.emailVerify || ' ' }
        fullWidth
      />

      <Typography className={classes.noteText}>
        Note: If you created your account using &lsquo;Sign in with Google&rsquo;, you cannot recover your password using this method.
      </Typography>
      <div className={classes.formButtons}>
        {isSending
? (
          <LoadingAnimation />
        )
: (
          <Button
            disabled={
              forgotEmail.length === 0
            }
            onClick={() => {
              if (typeof onSendRecovery === 'function') {
                onSendRecovery(forgotEmail);
              }
            }}

            variant="contained"
            color="primary"
            size="large"
          >
            Send
          </Button>
        )}
        <Button
          color="primary"
          size="large"
          onClick={() => onBackToLogin()}
          className={classes.forgetButton}
        >
          Back to login
        </Button>
      </div>

  </div>
  );
}

ForgotEmail.propTypes = {
  onSendRecovery: PropTypes.func,
  onBackToLogin: PropTypes.func,
};

export default observer(ForgotEmail);
